var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[(_vm.displayed)?[_c('WishlistMonit'),_vm._v(" "),(_vm.items.length)?_c('ProductsListWishlistHeader'):(!_vm.needFetch)?_c('EmptyListWishlistHeader'):_vm._e()]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }